export default __webpack_public_path__ + "static/media/icon-email-outbound.a79b5521.svg";